import Vue from 'vue'
import TorirSpectrogram from './TorirSpectrogram.vue'
import Controller from './components/Controller.vue'
import SpectrogramPlugin from './lib/plugin-spectrogram'

if (!window.WaveSurfer) {
	throw new Error('WaveSurfer not loaded.')
}
window.WaveSurfer.spectrogram = SpectrogramPlugin

Vue.config.productionTip = false

/**
 * @typedef {Object} TorirSpectrogramOption
 * @property {string} [colorMapName] カラーマップ名。Viridis, Cubehelix, Jet, HSV のいずれか
 * @property {number} [currentTime] 再生位置
 * @property {number} [fftSamples] FFT サンプル点数
 * @property {number} [frequencyMax] 表示周波数の下限
 * @property {number} [frequencyMin] 表示周波数の上限
 * @property {number} [height] スペクトログラムの高さ [px]
 * @property {number} [decibelMin] 値域の最小 [dB]
 * @property {number} [decibelMax] 値域の最大 [dB]
 * @property {number} [decibelBoost] ブースト境界値 [dB]
 * @property {number} [ratioBoost] ブースト率
 * @property {number} [decibelClip] クリップ境界値 [dB]
 * @property {number} [ratioClip] クリップ率
 * @property {number} [timeOffset] 時刻のオフセット [秒]。横軸の表示に使用する
 * @property {boolean} [mute] ミュート状態
 * @property {number} [playbackRate] 再生速度
 * @property {number} [volume] 音量（0 以上 1 以下の値）
 */

/**
 * スペクトログラム表示コンポーネントを初期化する
 *
 * @param {Element} container
 * @param {TorirSpectrogramOption} [options={}]
 * @returns Vue
 */
export function create (container, options = {}) {
	const appContainer = document.createElement('div')
	container.appendChild(appContainer)
	const app = new Vue({
		render: h => h(TorirSpectrogram, {
			ref: 'view',
			props: {
				options
			}
		})
	}).$mount(appContainer)
	return app.$refs.view
}

export function createController (container, spectrogram, options) {
	const appContainer = document.createElement('div')
	container.appendChild(appContainer)
	const app = new Vue({
		render: h => h(Controller, {
			ref: 'view',
			props: {
				spectrogram,
				options
			}
		})
	}).$mount(appContainer)
	return app.$refs.view
}

window.torirSpectrogram = {
	create,
	createController
}
